import React from 'react';
import { useTranslation } from 'react-i18next';
import Loader from '../components/common/Loader';
import StartButton from '../components/home5_residence/StartButton';

import InnerPageHeader from '../components/innerpage/InnerPageHeader';
import About from '../components/home7_landscape/About';
import Services from '../components/home7_landscape/Services';
import Project from '../components/home7_landscape/Project';
import Process from '../components/home1/Process'
import Testimonials from '../components/home7_landscape/Testimonials';
import Footer2 from "../components/home2/Footer";
import { Helmet } from 'react-helmet';

function Home7() {
  const { t } = useTranslation();

  const breadcrumbItems = [
    { label: t('pages.aboutUs.breadcrumb') }
  ];

  return (
    <>
      <Helmet>
        <link
          rel="stylesheet"
          type="text/css"
          href="/home7_landscape/assets/css/home_7_style.css"
        />
         <link
          rel="stylesheet"
          href="/home1/assets/css/home_1_style.css"
        />
        <link
          rel="stylesheet"
          href="/home2/assets/css/home_2_style.css"
        />
        <script src="/common/assets/js/common_js.js"></script>
        <script src="/home1/assets/js/home_1_scripts.js" defer></script>
        <script src="/home7_landscape/assets/js/home_7_scripts.js"></script>
         <meta
          name="description"
          content="Botanicheska 302 е нова жилищна сграда в Св. Св. Константин и Елена с модерна архитектура, апартаменти с панорама, зеленина и стилно ново строителство."
        />
      </Helmet>
      <body className="home-style7 home-style1 inner-page-header-active">
        <Loader />
        <div className="smooth-scroll-content" id="scrollsmoother-container">
          <InnerPageHeader 
            title={t('pages.aboutUs.title')}
            description={t('pages.aboutUs.description')}
            breadcrumbItems={breadcrumbItems}
            backgroundImage="/home1/assets/img/slider/slideimg.jpg"
          />
          <main>
            <About />
            <Services />
            {/* <Project /> */}
       

            
          </main>
          <Footer2 />
        </div>
        <StartButton />
      </body>
    </>
  );
}

export default Home7;
